// extracted by mini-css-extract-plugin
export default {"pagination":"CustomPagination_pagination__AuS5X","pageButton":"CustomPagination_pageButton__oYeZQ"};